import { ProgramModel } from '@modules/program/program-model';

const { fields } = ProgramModel;

export default [
  fields.name,
  fields.startDate,
  fields.endDate,
  fields.regStartDate,
  fields.regEndDate,
  fields.gender,
  fields.categories,
  // fields.seasons,
  fields.locations,
  fields.type,
];
